export const bulkExportUrlv2 = (process.env.REACT_APP_BULK || "/bulk-v2");
export const bulkExportUrl = (process.env.REACT_APP_BULK || "/bulk-v2") + "/bulkexport";
export const savedExortSettings = (process.env.REACT_APP_BULK ?? "/bulk-v2") + "/savedSettings";
export const bulkConfigurationApiUrl = (process.env.REACT_APP_API_URL ?? "/api") + "/bulkexport";